@if (dialogService.dialog$ | async; as currentDialog) {
  <app-dialog [presentation]="currentDialog.presentation || 'dialog'" [class.app-dialog--confirm]="!!currentDialog.actionLabel" [visible]="true" (visibleChange)="close()">
    <div class="modal-header">
      <h4 class="modal-title pull-left">{{ currentDialog.title }}</h4>
    </div>
    <div class="modal-body">{{ currentDialog.text }}</div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary btn-sm px-3" (click)="close()">{{ closeLabel(currentDialog) }}</button>
      @if (currentDialog.actionLabel) {
        <button type="button" class="btn btn-sm px-3" [class.btn-primary]="!currentDialog.destructive" [class.btn-danger]="currentDialog.destructive" (click)="runAction(currentDialog)">{{ currentDialog.actionLabel }}</button>
      }
    </div>
  </app-dialog>
}
